/**
 * Mobile Navigation Bar Component
 * Common navigation for all mobile pages
 */

import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './MobileNavBar.css';

function MobileNavBar() {
  const navigate = useNavigate();
  const location = useLocation();
  
  const getActiveTab = () => {
    const path = location.pathname;
    if (path === '/') return 'home';
    if (path === '/secure-notes') return 'notes';
    if (path === '/secure-files') return 'files';
    if (path === '/settings') return 'settings';
    return 'home';
  };
  
  const activeTab = getActiveTab();

  return (
    <div className="mobile-nav-bar">
      <button
        className={`mobile-nav-item ${activeTab === 'home' ? 'active' : ''}`}
        onClick={() => navigate('/')}
      >
        <span className="mobile-nav-icon">🔑</span>
        <span className="mobile-nav-label">패스워드</span>
      </button>
      
      <button
        className={`mobile-nav-item ${activeTab === 'notes' ? 'active' : ''}`}
        onClick={() => navigate('/secure-notes')}
      >
        <span className="mobile-nav-icon">📝</span>
        <span className="mobile-nav-label">메모</span>
      </button>
      
      <button
        className={`mobile-nav-item ${activeTab === 'files' ? 'active' : ''}`}
        onClick={() => navigate('/secure-files')}
      >
        <span className="mobile-nav-icon">📁</span>
        <span className="mobile-nav-label">파일</span>
      </button>
      
      <button
        className="mobile-nav-item"
        onClick={() => navigate('/shared-passwords')}
      >
        <span className="mobile-nav-icon">🔗</span>
        <span className="mobile-nav-label">공유</span>
      </button>
      
      <button
        className={`mobile-nav-item ${activeTab === 'settings' ? 'active' : ''}`}
        onClick={() => navigate('/settings')}
      >
        <span className="mobile-nav-icon">⚙️</span>
        <span className="mobile-nav-label">설정</span>
      </button>
    </div>
  );
}

export default MobileNavBar;